export default __webpack_public_path__ + "static/media/manatee.7acd907d.png";